export enum DiscountTypeEnum {
  Discount0 = 'DISCOUNT0',
  Discount5 = 'DISCOUNT5',
  Discount10 = 'DISCOUNT10',
  Discount20 = 'DISCOUNT20',
}
